import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProcessChartsComponent } from './process-charts.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { ComparisonComponent } from './components/comparison/comparison.component';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { UnauthorizedComponent } from 'src/app/shared/components/unauthorized/unauthorized.component';
import { CapabilityComponent } from './components/capability/capability.component';
import { ComparisonXrComponent } from './components/comparison-xr/comparison-xr.component';
import { SummaryComponent } from './components/summary/summary.component';

const unauthorized = '/spc/process-charts/no-privilage';

const routes: Routes = [
  {
    path: '',
    component: ProcessChartsComponent,
    children: [
      {
        path: 'statistics-continuous',
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['Statistics Continuous'],
            redirectTo: unauthorized,
          }
        },
        component: StatisticsComponent
      },
      {
        path: 'capability-charts',
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['Statistics Continuous'],
            redirectTo: unauthorized,
          }
        },
        component: CapabilityComponent
      },
      {
        path: 'comparison/i-charts',
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['Comparison Chart'],
            redirectTo: unauthorized,
          }
        },
        component: ComparisonComponent
      },
      {
        path: 'comparison/xbar-r',
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['Comparison Chart'],
            redirectTo: unauthorized,
          }
        },
        component: ComparisonXrComponent
      },
      {
        path: 'summary',
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['Statistics Continuous'],
            redirectTo: unauthorized,
          }
        },
        component: SummaryComponent
      },
      {
        path: 'no-privilage',
        component: UnauthorizedComponent
      },
      {
        path: '',
        redirectTo: 'statistics-continuous',
        pathMatch: 'full'
      }
    ]
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProcessChartsRoutingModule { }
